import type { TranslationModule } from '../types';

export const searchTranslations: TranslationModule = {
  ro: {
    demoCompanyFinancials: "Care sunt datele financiare ale societății VERDICT LINE SRL?",
    demoCompanyCases: "Verifică dacă societatea VERDICT LINE SRL are dosare pe rolul Judecătoriei Brașov.",
    demoCaseNotifications: "Poți să mă notifici când apare o modificare în dosarul meu nr. 1234/197/2026?",
    demoCaseLaw: "Caută jurisprudența ÎCCJ relevantă pentru prescripția dreptului material la acțiune.",
    demoFacts: "Am următoarea situație de fapt: am împrumutat unei persoane 30.000 lei, iar termenul de restituire a expirat. Găsește jurisprudență relevantă pentru cazul meu.",
    demoCivilCode: "Ce prevede art. 1357 din Codul civil și cum se aplică?",
    demoAudioInm: "Ai legislația în format audio doar pentru tematica de admitere la INM?",
    demoLegalSchemes: "Ai scheme juridice din care să învăț pentru examenul de admitere?",
    demoFactsMobile: "Am împrumutat 30.000 lei unei persoane, iar termenul de restituire a expirat. Găsește jurisprudență relevantă.",
    demoHint: "Începe să scrii aici — exemplele se opresc automat.",
    otherSourcesAction: "Caută și în celelalte surse",
    otherSourcesDescription: "Spețele similare folosesc căutarea semantică. Poți căuta același text și în legislație, CEDO, dicționar și celelalte surse, prin cuvinte-cheie.",
    backToResearch: "Înapoi la cercetarea începută",
    searchContextExpired: "Contextul căutării a expirat sau nu este disponibil pentru acest cont. Inițiază o nouă căutare.",
    partialSearchResults: "Verificarea este incompletă. Sunt afișate numai rezultatele disponibile.",

    motherDosareTitle: "Dosare și instanțe",
    motherDosareDesc: "Caută dosare pe rol, instanța competentă și date de contact ale instanțelor.",
    motherDosareSubtitle: "Alege secțiunea dorită pentru a consulta dosarele sau informațiile despre instanțe.",
    subDosarTitle: "Căutarea dosarelor",
    subDosarDesc: "Dosare în instanță căutate după număr sau părți implicate (persoane fizice ori juridice).",
    subCircumscriptiiTitle: "Competența instanțelor",
    subCircumscriptiiDesc: "Identifică instanțele arondate unei localități, străzi sau unui cod poștal.",
    subAgendaTitle: "Contacte instanțe și instituții",
    subAgendaDesc: "Date de contact ale instanțelor și instituțiilor juridice din România.",

    motherPersoaneTitle: "Firme și persoane",
    motherPersoaneDesc: "Informații despre companii ONRC, administratori, directori și reprezentanți legali.",
    motherPersoaneSubtitle: "Alege secțiunea dorită pentru a verifica firme sau persoane.",
    subPersoaneTitle: "Căutare persoane",
    subPersoaneDesc: "Administratori, directori și reprezentanți legali înregistrați la ONRC.",
    subFirmaTitle: "CUI / Denumire firmă",
    subFirmaDesc: "Date financiare, stare juridică și informații publice din bazele de date ONRC.",

    motherLegislatieTitle: "Legislație și documente",
    motherLegislatieDesc: "Acte normative actualizate, dicționar de termeni juridici și modele de documente.",
    motherLegislatieSubtitle: "Alege secțiunea dorită pentru a consulta legislația, dicționarul sau modelele de acte.",
    subLegislatieTitle: "Legislație",
    subLegislatieDesc: "Baza de date cu legi, ordonanțe și acte normative actualizate constant.",
    subDictionarTitle: "Dicționar juridic",
    subDictionarDesc: "Găsește definiții și explicații clare pentru termeni juridici.",
    subModeleTitle: "Modele documente & cereri",
    subModeleDesc: "Modele de acte, contracte și formulare juridice gata de completat.",
    jurisprudenceTitle: "Hotărâri și practică judiciară",
    nationalCourtsTitle: "Jurisprudență Instanțe Naționale",
    nationalCourtsDescription: "Curți de Apel, Tribunale și Judecătorii. Hotărâri judecătorești structurate pe materii.",
    practicaNeunitaraTitle: "Practică neunitară",
    practicaNeunitaraDescription: "Probleme de drept discutate pentru unificarea practicii instanțelor.",
    jurnalPracticaTitle: "Jurnal de practică judiciară",
    jurnalPracticaDescription: "Analize, culegeri și soluții relevante din practica instanțelor.",
    chooseJurisprudenceSubtitle: "Alege categoria dorită pentru a explora hotărârile și practica judiciară relevantă.",
    noJurisprudenceResults: "Nu am găsit hotărâri sau practică judiciară relevante pentru această căutare.",
    checkingAvailableSources: "Verificăm sursele disponibile…",
    iccjTitle: "Jurisprudență ÎCCJ",
    cedoTitle: "Jurisprudență CEDO",
    cedoDescription: "Cauze CEDO, cu rezumate, concluzii și pasajele relevante pentru căutarea ta.",
    cedoIncomplete: "Verificarea rezultatelor CEDO este incompletă.",
    iccjDescription: "Decizii ale Înaltei Curți, cu pasajele relevante pentru căutarea ta.",
    iccjIncomplete: "Verificarea rezultatelor ÎCCJ este incompletă.",

    capabilitiesTitle: "Cu ce te poate ajuta LegeaAplicată",
    capabilitiesIdentity: "LegeaAplicată este o platformă de cercetare juridică. Poți găsi acte normative, hotărâri, explicații juridice, modele de documente și informații din registrele disponibile.",
    capabilitiesDescription: "Alege funcția potrivită sau scrie ce vrei să afli. Poți folosi cuvinte obișnuite, întrebări, nume ori identificatori.",
    capabilitiesHint: "Acestea sunt funcțiile platformei. Rezultatele se verifică după introducerea unei căutări.",
    exploreFeatures: "Explorează funcțiile disponibile",
    showAllFeatures: "Vezi toate funcțiile platformei",
    openFeature: "Deschide funcția",
    capabilityCaseInput: "Introdu numărul complet al dosarului sau numele persoanei ori firmei ale cărei dosare te interesează.",
    capabilityPersonInput: "Introdu numele persoanei pentru a căuta rolurile și legăturile sale cu firmele înregistrate la ONRC.",
    capabilityCompanyInput: "Introdu denumirea firmei, CUI-ul sau numărul de înregistrare la Registrul Comerțului.",
    capabilitySimilarCasesTitle: "Cazuri asemănătoare situației tale",
    capabilitySimilarCasesDescription: "Descrie ce s-a întâmplat, cine este implicat și ce rezultat urmărești. Căutarea de spețe folosește descrierea integrală pentru a găsi situații asemănătoare.",
    incompleteSourcesTitle: "Verificarea surselor nu este completă",
    incompleteSourcesDescription: "Unele surse nu au răspuns. Nu putem confirma încă dacă există rezultate pentru această căutare. Poți reîncerca sau poți deschide o funcție mai jos.",
    globalSearchPlaceholder: "Întrebare, termen juridic, persoană, firmă sau dosar...",
    moreFactsTitle: "Completează situația de fapt",
    moreFactsDescription: "Ai introdus {count} caractere. Pentru spețe asemănătoare sunt necesare cel puțin {minimum}. Adaugă faptele, persoanele implicate și consecințele.",
    closeNotice: "Închide",
    lexicalCaseSearch: "Caută aceste cuvinte în jurisprudență",
    completeFacts: "Completează descrierea",
    semanticTooLong: "Păstrează cel mult {count} caractere în descriere.",
    interpretationFailed: "Interpretarea nu a putut fi finalizată. Reîncearcă.",
    seoTitle: "Analiză Juridică AI - Verificare Dosare & Spețe România",
    seoDesc: "Platformă profesională de analiză juridică. Nu este un chatbot. Introduceți date reale pentru a identifica spețe similare, hotărâri judecătorești relevante și a verifica situația financiară a firmelor.",
    searchTypeLabel: "Tip căutare:",
    keywords: "Cuvinte-cheie",
    speta: "Descriere spetă",
    spetaShort: "Speță",
    perspective: "Perspective",
    modulesSelected: "module selectate",
    moduleSelected: "modul selectat",
    keywordsSearch: "Caută în toate modulele",
    aiAnalysisLabel: "Analiză AI semantică",
    jurisAnalysisLabel: "Analiză jurisprudențială",
    viewPerspectiveBtn: "Vezi Perspective",
    placeholderKeywords: "Cuvinte-cheie, întrebări, persoane, firme sau dosare...",
    placeholderSpeta: "Descrieți situația juridică în detaliu (minim 200 caractere)...",
    examplesGroup: "Exemple căutare",
    factualEx: "Situație de Fapt",
    caseSearchEx: "Căutare Dosare",
    companyVerifEx: "Verificare Firmă",
    usefulLinksGroup: "Linkuri utile",
    docAnalysisLink: "Analiză Document",
    newsLink: "Știri Juridice",
    videoLink: "Video Juridic",
    eventsLink: "Evenimente",
    studentsLinksGroup: "Linkuri studenți",
    calculatorsSectionHeader: "CALCULATOARE",
    audioQuizzesLink: "Audio Grile",
    audioLegislationLink: "Audio Legislație",
    calculatorsLink: "Calculatoare",
    searchModulesHeader: "Caută în module",
    directSearchHeader: "Căutare directă",
    legalDocumentsHeader: "Documente juridice",
    optionalModules: "(opțional — gol = toate)",
    resetModules: "Resetează",
    infoBanner: "Introdu o întrebare sau termeni de căutare pentru a găsi informații în bazele de date.",
    bluetoothBannerBadge: "Unic în România! ©",
    bluetoothBannerTitle: "Grile Audio cu Telecomandă Bluetooth",
    bluetoothBannerDesc: "„Transformăm pregătirea pentru Barou, INM și examenele universitare într-o experiență mai liberă și mai naturală. Ascultă grilele în căști, răspunde prin telecomanda Bluetooth și învață fără presiunea unui spațiu închis. Mai puțină oboseală. Mai mult focus.”",
    bluetoothBannerAuthor: "Antoniu Olivian",
    bluetoothBannerRole: "Asociat VerdictLine",
    bluetoothBannerCTA: "Începe Sesiunea Audio →",
    placeholderKeywordsCount: "Cuvinte cheie pentru {count} module selectate...",
    mobileAttach: "Atașează",
    mobileDictate: "Dictează",
    mobileRemaining: "mai ai {count} caractere",
    mobileOptimal: "Optim",
    mobileOptionalLabel: "opțional",
    resetSelection: "Resetează selecția",
    searchBtn: "Caută",
    analyzingCategories: "Analizăm baza de date pentru identificarea categoriilor relevante...",
    fasterSearchHint: "Pentru un timp de răspuns mai scurt, vă recomandăm să selectați doar modulele de interes.",
    resultCount: "{count} rezultat",
    resultsCount: "{count} rezultate",
    benefitSmartTitle: "Căutare inteligentă",
    benefitSmartSub: "AI avansat",
    benefitFastTitle: "Răspuns rapid",
    benefitFastSub: "Rezultate relevante",
    benefitSecureTitle: "Securitate",
    benefitSecureSub: "Date protejate",
    mobileOptimalText: "Text optim pentru analiză",
    mobileRemainingCharacters: "mai ai {count} caractere",
    directSearchCategoryTitle: "Servicii și registre",
    selectSingleService: "Deschide un serviciu individual",
    desktopDirectNotice: "Serviciile și registrele se utilizează individual.",
    legalContentCategoryTitle: "Conținut juridic",
    selectMultipleSources: "Selectează una sau mai multe surse",
    desktopLegalNotice: "Poți selecta una sau mai multe surse din Conținut juridic.",
    desktopPlaceholderKeywords: "Caută o problemă juridică, un articol de lege, o firmă sau un dosar...",
    mainSearchPlaceholder: "Caută o problemă juridică, un articol de lege, o firmă sau un dosar...",
    integratedSearchLine1: "Căutare integrată în legislație, jurisprudență, practică judiciară, dicționar juridic, modele de documente și alte surse.",
    integratedSearchLine2: "Poți căuta și după număr de dosar, CUI, denumire firmă sau nume de persoană.",
    bannerKeywordsInfo: "Motor specializat de căutare și analiză juridică. Introdu cuvinte-cheie, o speță, un act normativ sau un număr de dosar.",
    bannerKeywordsInfoTitle: "Motor specializat de căutare și analiză juridică",
    bannerKeywordsInfoSub: "Introdu cuvinte-cheie, o speță, un act normativ sau un număr de dosar.",
    bannerConflictTitle: "Poți selecta module exclusiv dintr-o singură categorie. Alege fie un serviciu din «Servicii și registre», fie una sau mai multe surse din «Conținut juridic».",
    bannerConflictSubtitle: "Deselectează selecțiile din una dintre categorii pentru a continua.",
    sourcesAll: "Toate cele {count} surse",
    sourcesConflict: "Selecție incompatibilă",
    sourcesSingle: "{name}",
    sourcesCount: "{count} surse selectate",
    sourcesModalTitle: "Surse",
    sourcesModalSubtitle: "Personalizează modulele interogate",
    allModules: "Toate modulele",
    globalMode: "Mod global",
    popupConflictNote: "Ai selectat un serviciu din „Servicii și registre”. Deselectează-l pentru a alege surse din „Conținut juridic”.",
    popupEmptyNote: "Selectează cel puțin o sursă sau alege Toate modulele.",
    allModulesActive: "Toate modulele active",
    sourcesSelectedCount: "{count} surse selectate",
    sourcesSingleCount: "{count} sursă selectată",
    ecrisValidationTitle: "Introduceți cel puțin 2 caractere pentru căutarea în dosarele de judecată.",
    ecrisValidationExample: "Exemplu: Adrian Nicolau sau Verdict Line SRL",
    questionNoticeTitle: "Poți căuta folosind o întrebare.",
    questionNoticeDesc: "Identificăm informațiile relevante în sursele disponibile.",
    sourcesVerificationWarning: "Unele surse nu au putut fi verificate. Reîncearcă verificarea.",
    retryVerification: "Reîncearcă",
    companyIdentifiedBadge: "Companie detectată",
    done: "Gata",
    chooseSource: "Alege sursa în care vrei să continui",
    chooseSourceSubtitleConfirmed: "Am identificat informații în sursele de mai jos. Selectează una pentru a consulta rezultatele.",
    seeResults: "Vezi rezultatele",
    matterStageTitle: "În ce materie vrei să cauți?",
    matterStageSubtitle: "Am identificat hotărâri relevante în materiile de mai jos. Alege una pentru a continua.",
    seeCourtDecisions: "Vezi hotărârile",
    seeAllIncludingUnclassified: "Vezi toate hotărârile, inclusiv cele fără materie",
    matterDiscoveryFailed: "Nu am putut încărca materiile. Reîncercați.",
    chooseAnotherMatter: "Alege altă materie",
    backToSources: "Înapoi la surse",
    checkingAvailableMatters: "Verificăm materiile disponibile…",
    matterGenericDesc: "Consultă hotărârile judecătorești relevante din această materie.",
    listenLegislation: "Ascultă legislația",
    audioPrepTitle: "Pregătire audio pentru admitere",
    exploreOtherFeatures: "Explorează și alte funcții",
    audioBarouTitle: "Audio Admitere Barou",
    audioBarouDesc: "Ascultă legislația și materialele audio disponibile pentru pregătirea admiterii în avocatură.",
    audioInmTitle: "Audio Admitere INM",
    audioInmDesc: "Studiază audio legislația relevantă pentru pregătirea admiterii la INM.",
    audioSngTitle: "Audio Admitere SNG",
    audioSngDesc: "Ascultă legislația și materialele audio disponibile pentru pregătirea admiterii la SNG.",
    audioListenBadge: "Ascultă legislația",
    sources: {
      dictionar: { desc: "Descoperă definiții și explicații clare pentru termenii juridici." },
      legislatie: { desc: "Consultă articole din legi, coduri și alte acte normative." },
      modele: { desc: "Găsește modele de contracte, cereri și formulare juridice gata de completat." },
      jurisprudenta: { desc: "Caută hotărâri și soluții din jurisprudența instanțelor românești." },
      practica_neunitara: { desc: "Explorează probleme de drept analizate pentru unificarea practicii instanțelor." },
      jurnal_practica_judiciara: { desc: "Consultă analize, culegeri și soluții relevante din practica instanțelor." },
      firma: { desc: "Verifică firme după CUI sau denumire și consultă informațiile disponibile." },
      agenda: { desc: "Găsește datele de contact ale instanțelor și instituțiilor juridice." },
      circumscriptii: { desc: "Identifică instanțele arondate unei localități, străzi sau unui cod poștal." },
      persoane: { desc: "Identifică administratori și reprezentanți legali în datele disponibile despre firme." },
      litigii: { desc: "Consultă dosare în care figurează persoane fizice sau juridice." },
      dosar: { desc: "Caută un dosar după număr și consultă informațiile disponibile." },
    },
    chooseSourceSubtitle: "Am găsit rezultate în {found} din cele {total} surse selectate.",
    chooseSourceSubtitleSingle: "Am găsit rezultate într-o singură sursă din cele {total} selectate.",
    chooseSourceSubtitleGlobal: "Alege o categorie pentru a explora cele {count} rezultate găsite pentru „{query}”.",
    changeCategory: "Schimbă categoria",
    backToFoundSources: "Înapoi la sursele găsite",
    viewingResultsFromSource: "Vizualizezi rezultatele din {source}",
    noResultsInSources: "Niciun rezultat în sursele selectate",
    noResultsInSourcesDesc: "Nu am găsit documente pentru „{query}” în sursele selectate.",
    searchAllSources: "Caută în toate sursele",
    modifySources: "Modifică sursele",
    overviewError: "Nu am putut verifica momentan sursele selectate.",
    overviewErrorDesc: "A apărut o problemă de comunicare cu serverul de căutare.",
    retry: "Reîncearcă",
    backToSearch: "Înapoi la căutare",
    searchingInSources: "Căutăm în sursele selectate...",
    pageHeading: "Căutare și analiză juridică",
    pageDescription: "Caută după cuvinte-cheie, descrie o speță sau pornește de la textul unui document atașat.",
    similarCasesCta: "Nu cunoști termenii de drept? Găsește cazuri asemănătoare pe înțelesul tău →",
    sourcesRecommended: "Sursele căutării ({count}) · Recomandat",
    sourcesModalHeading: "Sursele căutării ({count})",
    sourcesModalSub: "Servicii, registre și conținut juridic",
    sourcesModalChooseHint: "Alege unde vrei să cauți. Nu știi ce să alegi? Păstrează modul global recomandat și începe căutarea; nu este nevoie să personalizezi selecția.",
    sourcesHowItWorks: "Cum funcționează?",
    sourcesStep1: "Introdu termenii de căutare sau datele cerute de serviciul ales.",
    sourcesStep2: "Păstrează modul global sau alege un serviciu individual ori unul sau mai multe module de conținut juridic.",
    sourcesStep3: "Apasă Aplică, apoi caută. Selecția stabilește pagina sau modulele de căutare; rezultatele depind de căutare și de datele disponibile.",
    sourcesTip1: "Pentru un articol de lege, alege {leg}. Pentru hotărâri, alege {juris}. Dacă nu știi unde este răspunsul, revino la modul global. Acesta folosește rutarea automată și nu garantează consultarea tuturor celor 12 opțiuni.",
    sourcesTip2: "Serviciile individuale nu se combină între ele sau cu modulele juridice. Selectorul este disponibil în modul Cuvinte-cheie; Speță și Perspective au trasee proprii.",
    resetToRecommended: "Revino la selecția recomandată",
    recommendedGlobalMode: "Mod global recomandat",
    attachmentHelp: "PDF, DOCX, TXT sau imagini · max. 10 MB · PDF: max. 3 pagini",
    closeAttachmentMessage: "Închide mesajul despre atașament",
    adequateLength: "Lungime adecvată",
    charactersNeeded: "{count} caractere necesare",
    neededForLegalIssues: "necesar pentru situații juridice",
    tryExample: "Încearcă un exemplu",
    maxCharsDesc: "Păstrează cel mult 8.000 de caractere în descriere.",
    maxCharsField: "Păstrează în câmp cel mult 8.000 de caractere pentru căutarea după speță.",
    maxCharsKeywords: "Păstrează în câmp cel mult 2.000 de caractere pentru căutarea după cuvinte-cheie.",
    listening: "Ascult...",
    backBtn: "Înapoi",
    keywordSearchBadge: "Căutare cuvinte cheie",
    caseNumberDetected: "Număr Dosar Detectat",
    ambiguousBadge: "Text Ambiguu",
    tellWhatHappened: "Povestește ce s-a întâmplat",
    caseSearch: "Căutare Dosar",
    companySearch: "Căutare Firmă",
    sessionExpiredNotice: "Sesiunea ta nu mai este activă. Pentru protecția contului și a datelor tale, te invităm să te autentifici din nou și să continui în siguranță.",
    legalSearchTitle: "Căutare juridică",
    directSearchLabel: "Introdu direct căutarea",
    directSearchHint: "Scrie direct în câmp sau alege un exemplu de mai jos.",
    searchExamples: "Exemple căutare",
    tryAnExample: "Încearcă un exemplu",
    previewExample: "Previzualizare exemplu",
    cancelBtn: "Anulează",
    closeBtn: "Închide",
    examplesPlatformFooter: "Exemple din funcționalitățile platformei.",
    seeAllFeatures: "Vezi toate funcțiile →",
    example_dosar_title: "Nr. dosar instanță",
    example_dosar_short: "Nr. dosar",
    example_dosar_desc: "Acesta este formatul unui număr de dosar. Poți modifica textul înainte de căutare.",
    example_firma_title: "CUI / Denumire firmă",
    example_firma_short: "Firmă / CUI",
    example_firma_desc: "Poți căuta o societate după denumirea sa oficială sau după CUI.",
    example_circumscriptii_title: "Instanța mea competentă",
    example_circumscriptii_short: "Instanța competentă",
    example_circumscriptii_desc: "Introdu o localitate pentru a afla instanțele judecătorești competente teritorial.",
    example_persoane_title: "Căutare persoane",
    example_persoane_short: "Persoane",
    example_persoane_desc: "Introdu numele unei persoane pentru a identifica informațiile disponibile despre aceasta în sursele platformei.",
    example_litigii_title: "Procese în justiție",
    example_litigii_desktop: "Procese active firme (ECRIS)",
    example_litigii_short: "Procese în justiție",
    example_litigii_desc: "Poți introduce numele unei persoane sau denumirea unei societăți pentru a verifica dosarele asociate în datele disponibile.",
    example_agenda_title: "Agendă",
    example_agenda_short: "Agendă",
    example_agenda_desc: "Caută instanțe, parchete sau instituții judiciare pentru a găsi date de contact și informații utile.",
    example_dictionar_title: "Dicționar",
    example_dictionar_short: "Dicționar",
    example_dictionar_desc: "Introdu termenul juridic pentru care cauți explicații.",
    example_legislatie_title: "Legislație",
    example_legislatie_short: "Legislație",
    example_legislatie_desc: "Poți introduce un articol de lege sau termeni dintr-un act normativ.",
    example_modele_title: "Modele documente & cereri",
    example_modele_short: "Modele documente",
    example_modele_desc: "Caută modele editabile de cereri, contracte sau acțiuni în justiție.",
    example_jurisprudenta_title: "Hotărâri judecătorești",
    example_jurisprudenta_short: "Hotărâri",
    example_jurisprudenta_desc: "Caută hotărâri judecătorești relevante și soluții pronunțate de instanțe.",
    example_practica_neunitara_title: "Practică neunitară",
    example_practica_neunitara_short: "Practică neunitară",
    example_practica_neunitara_desc: "Identifică deciziile privind recursurile în interesul legii și hotărârile prealabile.",
    example_analiza_contract_title: "Analiză contract (AI)",
    example_analiza_contract_short: "Analiză contract",
    example_analiza_contract_desc: "Lipește un contract sau act adițional pentru identificarea automată a clauzelor și corelare legislativă.",
    example_jurnal_practica_judiciara_title: "Jurnal de practică judiciară",
    example_jurnal_practica_judiciara_short: "Jurnal de practică",
    example_jurnal_practica_judiciara_desc: "Explorează sinteze și comentarii recente din practica instanțelor.",
    llmWelcomeTitle: "Un mesaj din partea LLM-ului",
    llmWelcomeGreeting: "Bună ziua!",
    llmWelcomeBody: "Din respect pentru justiție și drepturile dumneavoastră, nu **ofer consultații** sau **recomandări juridice**. Vă ajut să descoperiți și să comparați spețe asemănătoare, pentru a lua decizii în cunoștință de cauză, alături de un avocat informat.",
    llmWelcomeInstruction: "Introduceți direct textul, fără introduceri sau întrebări. Vă voi ghida atunci când este necesar.",
    llmWelcomeSignature: "Cu considerație,\nLLM-ul LegeaAplicată.",
    llmWelcomeConfirm: "Am înțeles. Să începem! →",
    aiNav: {
      title: "Navigare asistată AI",
      manualSwitch: "Navigare manuală",
      cancel: "Oprește",
      selectPrompt: "Selectează opțiunea potrivită pentru a continua:",
      unsupportedConstraintsTitle: "Unele condiții din solicitarea ta nu sunt disponibile ca filtre automate și au fost excluse:",
      stage: {
        interpreting_request: "Interpretăm solicitarea juridică…",
        searching_sources: "Verificăm sursele și registrele disponibile…",
        awaiting_court_selection: "Selectează instanța dorită pentru a continua",
        preparing_results: "Pregătim rezultatele relevante…",
        completed: "Navigare finalizată",
      },
    },
    llmWelcomeFootnote: "Se afișează o singură dată și poate fi redeschis din pagină.",
    llmWelcomeReopen: "Un mesaj din partea LLM-ului",
    rerankUpsellTitle: "Au fost identificate {relevantCount} spețe relevante",
    rerankUpsellBasicDesc: "Sunt afișate cele mai relevante {displayedCount}, conform abonamentului Basic. Abonamentul Pro permite afișarea a până la 50 de spețe relevante pentru fiecare căutare.",
    rerankUpsellGuestDesc: "Sunt afișate cele mai relevante {displayedCount} pentru vizitatori. Creează un cont gratuit Basic pentru până la 20 de spețe relevante sau alege Pro pentru până la 50 de spețe relevante.",
    rerankUpsellCtaPro: "Deblochează Pro",
    rerankUpsellCtaGuest: "Vezi abonamentele",
    rerankProSummary: "Au fost analizate {candidateCount} spețe candidate. Sunt afișate {displayedCount} spețe relevante, începând cu cea mai relevantă.",
    rerankAllRelevantShown: "Sunt afișate toate cele {displayedCount} spețe care au trecut pragul de relevanță."
  },
  en: {
    demoCompanyFinancials: "What are the financial figures for VERDICT LINE SRL?",
    demoCompanyCases: "Check whether VERDICT LINE SRL has cases pending before the Brașov District Court.",
    demoCaseNotifications: "Can you notify me when there is an update in my case no. 1234/197/2026?",
    demoCaseLaw: "Find relevant High Court case law on the limitation period for the substantive right of action.",
    demoFacts: "Here are the facts: I lent someone 30,000 lei and the repayment deadline has passed. Find relevant case law for my situation.",
    demoCivilCode: "What does Article 1357 of the Civil Code provide and how does it apply?",
    demoAudioInm: "Do you have audio legislation covering only the INM entrance exam syllabus?",
    demoLegalSchemes: "Do you have legal diagrams I can study for the entrance exam?",
    demoFactsMobile: "I lent someone 30,000 lei and the repayment deadline has passed. Find relevant case law.",
    demoHint: "Start typing here — the examples stop automatically.",
    otherSourcesAction: "Search the other sources too",
    otherSourcesDescription: "Similar cases use semantic search. You can also search the same text in legislation, ECHR materials, the dictionary and other sources using keywords.",
    backToResearch: "Back to your research",
    searchContextExpired: "The search context has expired or is unavailable for this account. Start a new search.",
    partialSearchResults: "Verification is incomplete. Only the available results are shown.",

    motherDosareTitle: "Cases and Courts",
    motherDosareDesc: "Search court dockets, competent courts, and court contact directories.",
    motherDosareSubtitle: "Choose a section to view court cases or court jurisdiction details.",
    subDosarTitle: "Case Search",
    subDosarDesc: "Court dockets searched by case number or involved parties.",
    subCircumscriptiiTitle: "Court Jurisdiction",
    subCircumscriptiiDesc: "Identify competent courts assigned to a locality, street, or postal code.",
    subAgendaTitle: "Court and Institution Contacts",
    subAgendaDesc: "Contact details for Romanian courts and legal institutions.",

    motherPersoaneTitle: "Companies and Individuals",
    motherPersoaneDesc: "Trade Register information on companies, directors, and legal representatives.",
    motherPersoaneSubtitle: "Choose a section to verify companies or individuals.",
    subPersoaneTitle: "Person Search",
    subPersoaneDesc: "Company administrators, directors, and legal representatives.",
    subFirmaTitle: "Tax ID / Company Name",
    subFirmaDesc: "Financial data, legal status, and Trade Register records.",

    motherLegislatieTitle: "Legislation and Documents",
    motherLegislatieDesc: "Updated normative acts, legal terms dictionary, and document templates.",
    motherLegislatieSubtitle: "Choose a section to access legislation, definitions, or document templates.",
    subLegislatieTitle: "Legislation",
    subLegislatieDesc: "Continuously updated laws, ordinances, and normative acts.",
    subDictionarTitle: "Legal Dictionary",
    subDictionarDesc: "Clear definitions and explanations for Romanian legal terms.",
    subModeleTitle: "Document Templates & Forms",
    subModeleDesc: "Ready-to-fill contract templates, applications, and legal forms.",
    jurisprudenceTitle: "Court Decisions and Judicial Practice",
    nationalCourtsTitle: "National Court Case Law",
    nationalCourtsDescription: "Courts of Appeal, Tribunals, and First-Instance Courts.",
    practicaNeunitaraTitle: "Non-Unitary Practice",
    practicaNeunitaraDescription: "Legal issues analyzed to unify court practice.",
    jurnalPracticaTitle: "Judicial Practice Journal",
    jurnalPracticaDescription: "Analyses, digests, and key rulings from court practice.",
    chooseJurisprudenceSubtitle: "Choose a category to explore relevant judgments and case law.",
    noJurisprudenceResults: "No relevant court decisions or practice found for this search.",
    checkingAvailableSources: "Checking available sources…",
    iccjTitle: "High Court case law",
    cedoTitle: "ECHR case law",
    cedoDescription: "ECHR cases with summaries, conclusions and passages matching your search.",
    cedoIncomplete: "The ECHR result check is incomplete.",
    iccjDescription: "High Court decisions with passages matching your search.",
    iccjIncomplete: "The High Court result check is incomplete.",

    capabilitiesTitle: "How LegeaAplicată can help",
    capabilitiesIdentity: "LegeaAplicată is a legal research platform. Find legislation, court decisions, legal definitions, document templates and information from the available registers.",
    capabilitiesDescription: "Choose a feature or describe what you want to find. You can use everyday words, questions, names or identifiers.",
    capabilitiesHint: "These are platform features. Matching results are checked after you enter a search.",
    exploreFeatures: "Explore available features",
    showAllFeatures: "View all platform features",
    openFeature: "Open feature",
    capabilityCaseInput: "Enter a full case number, or the name of the person or company whose cases you want to find.",
    capabilityPersonInput: "Enter a person’s name to search their roles and links to companies registered with ONRC.",
    capabilityCompanyInput: "Enter the company name, tax ID or Trade Register number.",
    capabilitySimilarCasesTitle: "Cases similar to your situation",
    capabilitySimilarCasesDescription: "Describe what happened, who is involved and the outcome you seek. Similar-case search uses the full description to find related situations.",
    incompleteSourcesTitle: "Source verification is incomplete",
    incompleteSourcesDescription: "Some sources did not respond. We cannot yet confirm whether this search has matches. Retry or open a feature below.",
    globalSearchPlaceholder: "Question, legal term, person, company or case number...",
    moreFactsTitle: "Add details about the facts",
    moreFactsDescription: "You entered {count} characters. Similar case search needs at least {minimum}. Add the events, people involved and consequences.",
    closeNotice: "Close",
    lexicalCaseSearch: "Search these words in case law",
    completeFacts: "Complete the description",
    semanticTooLong: "Keep the description within {count} characters.",
    interpretationFailed: "The search could not be interpreted. Please retry.",
    seoTitle: "AI Legal Analysis - Case Law Search & Company Registry Romania",
    seoDesc: "Professional legal analysis platform. Not a generic chatbot. Input real factual data to identify similar case files, relevant judicial decisions, and verify corporate financials.",
    searchTypeLabel: "Search Type:",
    keywords: "Keywords",
    speta: "Statement of Facts",
    spetaShort: "Case Description",
    perspective: "Perspectives",
    modulesSelected: "modules selected",
    moduleSelected: "module selected",
    keywordsSearch: "Search All Modules",
    aiAnalysisLabel: "Semantic AI Analysis",
    jurisAnalysisLabel: "Jurisprudential Analysis",
    viewPerspectiveBtn: "View Perspectives",
    placeholderKeywords: "Keywords, questions, people, companies or cases...",
    placeholderSpeta: "Describe the legal situation in detail (minimum 200 characters)...",
    examplesGroup: "Search Examples",
    factualEx: "Factual Scenario",
    caseSearchEx: "Case File Lookup",
    companyVerifEx: "Verify Company",
    usefulLinksGroup: "Useful Links",
    docAnalysisLink: "Analyze Document",
    newsLink: "Legal News",
    videoLink: "Legal Video",
    eventsLink: "Events",
    studentsLinksGroup: "Students Section",
    calculatorsSectionHeader: "CALCULATORS",
    audioQuizzesLink: "Audio Quizzes",
    audioLegislationLink: "Audio Legislation",
    calculatorsLink: "Calculators",
    searchModulesHeader: "Search in Modules",
    directSearchHeader: "Direct search",
    legalDocumentsHeader: "Legal documents",
    optionalModules: "(optional — empty = search all)",
    resetModules: "Reset",
    infoBanner: "Enter a question or search terms to find information in the databases.",
    bluetoothBannerBadge: "Unique in Romania! ©",
    bluetoothBannerTitle: "Audio Quizzes with Bluetooth Remote Control",
    bluetoothBannerDesc: "“We transform preparation for the Bar Exam, INM, and university law exams into a freer, more natural experience. Listen to cases in your headphones, answer via the Bluetooth remote, and study without the pressure of a closed space. Less fatigue. Higher focus.”",
    bluetoothBannerAuthor: "Antoniu Olivian",
    bluetoothBannerRole: "Asociate at VerdictLine",
    bluetoothBannerCTA: "Start Audio Session →",
    placeholderKeywordsCount: "Keywords for {count} selected modules...",
    mobileAttach: "Attach",
    mobileDictate: "Dictate",
    mobileRemaining: "{count} characters remaining",
    mobileOptimal: "Optimal",
    mobileOptionalLabel: "optional",
    resetSelection: "Reset selection",
    searchBtn: "Search",
    analyzingCategories: "We are analyzing the database to identify the relevant categories...",
    fasterSearchHint: "For a shorter response time, we recommend selecting only the modules relevant to your search.",
    resultCount: "{count} result",
    resultsCount: "{count} results",
    benefitSmartTitle: "Smart Search",
    benefitSmartSub: "Advanced AI",
    benefitFastTitle: "Fast Response",
    benefitFastSub: "Relevant results",
    benefitSecureTitle: "Security",
    benefitSecureSub: "Protected data",
    mobileOptimalText: "Optimal text for analysis",
    mobileRemainingCharacters: "{count} characters remaining",
    directSearchCategoryTitle: "Services & Registries",
    selectSingleService: "Open an individual service",
    desktopDirectNotice: "Services and registries are used individually.",
    legalContentCategoryTitle: "Legal Content",
    selectMultipleSources: "Select one or more sources",
    desktopLegalNotice: "You can select one or more sources from Legal Content.",
    desktopPlaceholderKeywords: "Search for a legal issue, a statute, a company or a case file...",
    mainSearchPlaceholder: "Search for a legal issue, a statute, a company or a case file...",
    integratedSearchLine1: "Integrated search across legislation, case law, judicial practice, legal dictionary, document templates and other sources.",
    integratedSearchLine2: "You can also search by case file number, tax ID, company name or person name.",
    bannerKeywordsInfo: "Specialized legal search and analysis engine. Enter keywords, case text, a normative act or a case file number.",
    bannerKeywordsInfoTitle: "Specialized Legal Search & Analysis Engine",
    bannerKeywordsInfoSub: "Enter keywords, case text, a normative act or a case file number.",
    bannerConflictTitle: "You can select modules from only one category at a time. Choose either a service from \"Services & Registries\" or one or more sources from \"Legal Content\".",
    bannerConflictSubtitle: "Deselect selections from one of the categories to proceed.",
    sourcesAll: "All {count} sources",
    sourcesConflict: "Conflicting selection",
    sourcesSingle: "{name}",
    sourcesCount: "{count} sources selected",
    sourcesModalTitle: "Sources",
    sourcesModalSubtitle: "Customize queried modules",
    allModules: "All modules",
    globalMode: "Global mode",
    popupConflictNote: "You have selected a service from \"Services & Registries\". Deselect it to choose sources from \"Legal Content\".",
    popupEmptyNote: "Select at least one source or choose All modules.",
    allModulesActive: "All modules active",
    sourcesSelectedCount: "{count} sources selected",
    sourcesSingleCount: "{count} source selected",
    ecrisValidationTitle: "Enter at least 2 characters to search court cases.",
    ecrisValidationExample: "Example: Adrian Nicolau or Verdict Line SRL",
    questionNoticeTitle: "You can search using a question.",
    questionNoticeDesc: "We find relevant information in the available sources.",
    sourcesVerificationWarning: "Some sources could not be verified. Please retry verification.",
    retryVerification: "Retry",
    companyIdentifiedBadge: "Company detected",
    done: "Done",
    chooseSource: "Choose the source to continue",
    chooseSourceSubtitleConfirmed: "We found information in the sources below. Select one to view results.",
    seeResults: "View results",
    matterStageTitle: "Which area of law would you like to search?",
    matterStageSubtitle: "We found relevant court decisions in the areas below. Choose one to continue.",
    seeCourtDecisions: "View court decisions",
    seeAllIncludingUnclassified: "View all decisions, including unclassified ones",
    matterDiscoveryFailed: "Could not load legal matters. Please retry.",
    chooseAnotherMatter: "Choose another area of law",
    backToSources: "Back to sources",
    checkingAvailableMatters: "Checking available areas of law…",
    matterGenericDesc: "Consult relevant court decisions in this area of law.",
    listenLegislation: "Listen to legislation",
    audioPrepTitle: "Audio Exam Preparation",
    exploreOtherFeatures: "Explore other features",
    audioBarouTitle: "Audio Bar Exam Prep",
    audioBarouDesc: "Listen to legislation and audio materials for the Bar admission exam.",
    audioInmTitle: "Audio INM Exam Prep",
    audioInmDesc: "Study audio legislation relevant for INM magistrate admission.",
    audioSngTitle: "Audio SNG Exam Prep",
    audioSngDesc: "Listen to legislation and audio materials for SNG court clerk admission.",
    audioListenBadge: "Listen to legislation",
    sources: {
      dictionar: { desc: "Discover clear definitions and explanations for legal terms." },
      legislatie: { desc: "Consult articles from laws, codes, and other normative acts." },
      modele: { desc: "Find contract templates, motions, and ready-to-fill legal forms." },
      jurisprudenta: { desc: "Search rulings and solutions from Romanian case law." },
      practica_neunitara: { desc: "Explore legal issues analyzed to unify court practice." },
      jurnal_practica_judiciara: { desc: "Consult analyses, digests, and key rulings from court practice." },
      firma: { desc: "Verify companies by CUI or commercial name and explore available data." },
      agenda: { desc: "Find contact details for courts and judicial institutions." },
      circumscriptii: { desc: "Identify competent courts assigned to a locality, street, or postal code." },
      persoane: { desc: "Identify company administrators and legal representatives in available corporate data." },
      litigii: { desc: "Consult court cases involving individuals or legal entities." },
      dosar: { desc: "Search a court case by number and view available information." },
    },
    chooseSourceSubtitle: "Found results in {found} of the {total} selected sources.",
    chooseSourceSubtitleSingle: "Found results in 1 of the {total} selected sources.",
    chooseSourceSubtitleGlobal: "Choose a category to explore the {count} results found for “{query}”.",
    changeCategory: "Change category",
    backToFoundSources: "Back to found sources",
    viewingResultsFromSource: "You are viewing results from {source}",
    noResultsInSources: "No results found in selected sources",
    noResultsInSourcesDesc: "We did not find documents for “{query}” in the selected sources.",
    searchAllSources: "Search all sources",
    modifySources: "Modify sources",
    overviewError: "Could not verify selected sources at this time.",
    overviewErrorDesc: "A communication problem occurred with the search server.",
    retry: "Retry",
    backToSearch: "Back to search",
    searchingInSources: "Searching in selected sources...",
    pageHeading: "Legal Search and Analysis",
    pageDescription: "Search by keywords, describe a case, or start from text in an attached document.",
    similarCasesCta: "Unfamiliar with legal terms? Find similar cases in plain language →",
    sourcesRecommended: "Search sources ({count}) · Recommended",
    sourcesModalHeading: "Search sources ({count})",
    sourcesModalSub: "Services, registries and legal content",
    sourcesModalChooseHint: "Choose where you want to search. Not sure? Keep the recommended global mode and start searching; no need to customize.",
    sourcesHowItWorks: "How does it work?",
    sourcesStep1: "Enter search terms or data required by the chosen service.",
    sourcesStep2: "Keep global mode or choose an individual service or one or more legal content modules.",
    sourcesStep3: "Click Apply, then search. The selection determines search pages or modules; results depend on the query and available data.",
    sourcesTip1: "For a statutory article, choose {leg}. For court rulings, choose {juris}. If not sure where the answer lies, return to global mode. It uses automatic routing and does not guarantee querying all 12 options.",
    sourcesTip2: "Individual services cannot be combined with each other or legal modules. The selector is available in Keywords mode; Case and Perspectives follow their own paths.",
    resetToRecommended: "Reset to recommended selection",
    recommendedGlobalMode: "Recommended global mode",
    attachmentHelp: "PDF, DOCX, TXT or images · max. 10 MB · PDF: max. 3 pages",
    closeAttachmentMessage: "Dismiss attachment message",
    adequateLength: "Adequate length",
    charactersNeeded: "{count} characters needed",
    neededForLegalIssues: "required for legal situations",
    tryExample: "Try an example",
    maxCharsDesc: "Keep at most 8,000 characters in the description.",
    maxCharsField: "Keep at most 8,000 characters in the field for case law search.",
    maxCharsKeywords: "Keep at most 2,000 characters in the field for keyword search.",
    listening: "Listening...",
    backBtn: "Back",
    keywordSearchBadge: "Keyword search",
    caseNumberDetected: "Case Number Detected",
    ambiguousBadge: "Ambiguous Text",
    tellWhatHappened: "Tell us what happened",
    caseSearch: "Case Search",
    companySearch: "Company Search",
    sessionExpiredNotice: "Your session is no longer active. To protect your account and data, please log in again to continue safely.",
    legalSearchTitle: "Legal search",
    directSearchLabel: "Enter your search directly",
    directSearchHint: "Type directly in the field or choose an example below.",
    searchExamples: "Search examples",
    tryAnExample: "Try an example",
    previewExample: "Example preview",
    cancelBtn: "Cancel",
    closeBtn: "Close",
    examplesPlatformFooter: "Examples from platform features.",
    seeAllFeatures: "See all features →",
    example_dosar_title: "Court case number",
    example_dosar_short: "Case number",
    example_dosar_desc: "This is the format of a case number. You can modify the text before searching.",
    example_firma_title: "Tax ID / Company name",
    example_firma_short: "Company / Tax ID",
    example_firma_desc: "You can search for a company by its official name or tax ID.",
    example_circumscriptii_title: "My competent court",
    example_circumscriptii_short: "Competent court",
    example_circumscriptii_desc: "Enter a location to find territorially competent courts.",
    example_persoane_title: "Person search",
    example_persoane_short: "Persons",
    example_persoane_desc: "Enter a person's name to identify available information in platform sources.",
    example_litigii_title: "Court proceedings",
    example_litigii_desktop: "Active court cases (ECRIS)",
    example_litigii_short: "Court cases",
    example_litigii_desc: "You can enter a person or company name to check associated court cases in available records.",
    example_agenda_title: "Directory",
    example_agenda_short: "Directory",
    example_agenda_desc: "Search courts, prosecutor offices, or judicial institutions for contact details.",
    example_dictionar_title: "Legal dictionary",
    example_dictionar_short: "Dictionary",
    example_dictionar_desc: "Enter the legal term you need explanations for.",
    example_legislatie_title: "Legislation",
    example_legislatie_short: "Legislation",
    example_legislatie_desc: "You can enter a legal article or terms from a statute.",
    example_modele_title: "Document & request templates",
    example_modele_short: "Templates",
    example_modele_desc: "Search editable templates for petitions, contracts, or court actions.",
    example_jurisprudenta_title: "Court rulings",
    example_jurisprudenta_short: "Rulings",
    example_jurisprudenta_desc: "Search relevant court judgments and judicial decisions.",
    example_practica_neunitara_title: "Conflicting case law",
    example_practica_neunitara_short: "Conflicting law",
    example_practica_neunitara_desc: "Identify appeals in the interest of the law and preliminary rulings.",
    example_analiza_contract_title: "Contract analysis (AI)",
    example_analiza_contract_short: "Contract analysis",
    example_analiza_contract_desc: "Paste a contract or addendum for automated clause detection and legal cross-referencing.",
    example_jurnal_practica_judiciara_title: "Judicial practice journal",
    example_jurnal_practica_judiciara_short: "Practice journal",
    example_jurnal_practica_judiciara_desc: "Explore recent summaries and commentaries from court practice.",
    llmWelcomeTitle: "A message from the LLM",
    llmWelcomeGreeting: "Hello!",
    llmWelcomeBody: "Out of respect for justice and your rights, I do not provide **legal consultations** or **recommendations**. I help you discover and compare similar cases, so you can make informed decisions alongside qualified legal counsel.",
    llmWelcomeInstruction: "Enter your text directly, without introductions or pleasantries. I will guide you when necessary.",
    llmWelcomeSignature: "Respectfully,\nThe LegeaAplicată LLM.",
    llmWelcomeConfirm: "Understood. Let's start! →",
    aiNav: {
      title: "AI Assisted Navigation",
      manualSwitch: "Manual navigation",
      cancel: "Stop",
      selectPrompt: "Select the matching option to continue:",
      unsupportedConstraintsTitle: "Some conditions in your request are not supported as automatic filters and were excluded:",
      stage: {
        interpreting_request: "Interpreting legal request…",
        searching_sources: "Checking available sources and registries…",
        awaiting_court_selection: "Select the court to continue",
        preparing_results: "Preparing relevant results…",
        completed: "Navigation complete",
      },
    },
    llmWelcomeFootnote: "Displayed only once and can be reopened from the page.",
    llmWelcomeReopen: "A message from the LLM",
    rerankUpsellTitle: "{relevantCount} relevant cases identified",
    rerankUpsellBasicDesc: "Showing the top {displayedCount} most relevant cases under your Basic plan. The Pro plan unlocks up to 50 relevant cases per search.",
    rerankUpsellGuestDesc: "Showing the top {displayedCount} most relevant cases for visitors. Create a free Basic account for up to 20 relevant cases or upgrade to Pro for up to 50 relevant cases.",
    rerankUpsellCtaPro: "Unlock Pro",
    rerankUpsellCtaGuest: "View plans",
    rerankProSummary: "Analyzed {candidateCount} candidate cases. Showing {displayedCount} relevant cases, ordered by relevance.",
    rerankAllRelevantShown: "Showing all {displayedCount} cases that passed the relevance threshold."
  },
  fr: {
    demoCompanyFinancials: "Quelles sont les données financières de la société VERDICT LINE SRL ?",
    demoCompanyCases: "Vérifie si la société VERDICT LINE SRL a des affaires en cours devant le tribunal de première instance de Brașov.",
    demoCaseNotifications: "Peux-tu me prévenir lorsqu’il y a un changement dans mon dossier n° 1234/197/2026 ?",
    demoCaseLaw: "Recherche la jurisprudence de la Haute Cour pertinente sur la prescription du droit matériel à l’action.",
    demoFacts: "Voici les faits : j’ai prêté 30 000 lei à une personne et le délai de remboursement est dépassé. Trouve la jurisprudence pertinente pour mon cas.",
    demoCivilCode: "Que prévoit l’article 1357 du Code civil et comment s’applique-t-il ?",
    demoAudioInm: "As-tu la législation en format audio limitée au programme du concours d’entrée à l’INM ?",
    demoLegalSchemes: "As-tu des schémas juridiques pour préparer le concours d’entrée ?",
    demoFactsMobile: "J’ai prêté 30 000 lei à une personne et le délai de remboursement est dépassé. Trouve la jurisprudence pertinente.",
    demoHint: "Commence à écrire ici — les exemples s’arrêtent automatiquement.",
    otherSourcesAction: "Rechercher aussi dans les autres sources",
    otherSourcesDescription: "Les affaires similaires utilisent la recherche sémantique. Vous pouvez aussi rechercher le même texte dans la législation, les documents CEDH, le dictionnaire et les autres sources par mots-clés.",
    backToResearch: "Revenir à votre recherche",
    searchContextExpired: "Le contexte de recherche a expiré ou est indisponible pour ce compte. Lancez une nouvelle recherche.",
    partialSearchResults: "La vérification est incomplète. Seuls les résultats disponibles sont affichés.",

    motherDosareTitle: "Dossiers et tribunaux",
    motherDosareDesc: "Recherchez des dossiers, tribunaux compétents et annuaires judiciaires.",
    motherDosareSubtitle: "Choisissez une section pour consulter les dossiers ou informations sur les tribunaux.",
    subDosarTitle: "Recherche de dossiers",
    subDosarDesc: "Dossiers judiciaires recherchés par numéro ou parties impliquées.",
    subCircumscriptiiTitle: "Compétence des tribunaux",
    subCircumscriptiiDesc: "Identifiez les tribunaux compétents pour une localité, rue ou code postal.",
    subAgendaTitle: "Contacts des tribunaux et institutions",
    subAgendaDesc: "Coordonnées des tribunaux et institutions judiciaires en Roumanie.",

    motherPersoaneTitle: "Entreprises et personnes",
    motherPersoaneDesc: "Informations sur les sociétés, administrateurs et représentants légaux.",
    motherPersoaneSubtitle: "Choisissez une section pour vérifier des entreprises ou des personnes.",
    subPersoaneTitle: "Recherche de personnes",
    subPersoaneDesc: "Administrateurs, directeurs et représentants légaux inscrits au registre.",
    subFirmaTitle: "Identifiant fiscal / Société",
    subFirmaDesc: "Données financières, statut juridique et informations du registre du commerce.",

    motherLegislatieTitle: "Législation et documents",
    motherLegislatieDesc: "Textes normatifs à jour, dictionnaire juridique et modèles de documents.",
    motherLegislatieSubtitle: "Choisissez une section pour consulter la législation, le dictionnaire ou les modèles.",
    subLegislatieTitle: "Législation",
    subLegislatieDesc: "Lois, ordonnances et actes normatifs mis à jour en continu.",
    subDictionarTitle: "Dictionnaire juridique",
    subDictionarDesc: "Définitions et explications claires des termes juridiques.",
    subModeleTitle: "Modèles de documents & requêtes",
    subModeleDesc: "Modèles de contrats, requêtes et formulaires juridiques prêts à l'emploi.",
    jurisprudenceTitle: "Décisions et pratique judiciaire",
    nationalCourtsTitle: "Jurisprudence des juridictions nationales",
    nationalCourtsDescription: "Cours d'appel, tribunaux de grande instance et tribunaux d'instance.",
    practicaNeunitaraTitle: "Pratique judiciaire divergente",
    practicaNeunitaraDescription: "Questions de droit analysées pour l'unification de la jurisprudence.",
    jurnalPracticaTitle: "Journal de pratique judiciaire",
    jurnalPracticaDescription: "Analyses, recueils et décisions pertinentes de la pratique judiciaire.",
    chooseJurisprudenceSubtitle: "Choisissez une catégorie pour explorer les décisions et la jurisprudence pertinentes.",
    noJurisprudenceResults: "Aucune décision ou jurisprudence pertinente trouvée pour cette recherche.",
    checkingAvailableSources: "Vérification des sources disponibles…",
    iccjTitle: "Jurisprudence de la Haute Cour",
    cedoTitle: "Jurisprudence de la CEDH",
    cedoDescription: "Affaires de la CEDH avec résumés, conclusions et passages pertinents pour votre recherche.",
    cedoIncomplete: "La vérification des résultats de la CEDH est incomplète.",
    iccjDescription: "Décisions de la Haute Cour avec les passages pertinents pour votre recherche.",
    iccjIncomplete: "La vérification des résultats de la Haute Cour est incomplète.",

    capabilitiesTitle: "Comment LegeaAplicată peut vous aider",
    capabilitiesIdentity: "LegeaAplicată est une plateforme de recherche juridique. Retrouvez des textes législatifs, décisions, définitions, modèles de documents et informations issues des registres disponibles.",
    capabilitiesDescription: "Choisissez une fonction ou décrivez votre recherche. Vous pouvez utiliser des mots courants, des questions, des noms ou des identifiants.",
    capabilitiesHint: "Voici les fonctions de la plateforme. Les résultats sont vérifiés après la saisie d’une recherche.",
    exploreFeatures: "Explorer les fonctions disponibles",
    showAllFeatures: "Voir toutes les fonctions de la plateforme",
    openFeature: "Ouvrir la fonction",
    capabilityCaseInput: "Saisissez le numéro complet du dossier ou le nom de la personne ou de la société dont vous recherchez les dossiers.",
    capabilityPersonInput: "Saisissez le nom d’une personne pour rechercher ses fonctions et liens avec les sociétés inscrites à l’ONRC.",
    capabilityCompanyInput: "Saisissez le nom de la société, son identifiant fiscal ou son numéro au registre du commerce.",
    capabilitySimilarCasesTitle: "Des affaires similaires à votre situation",
    capabilitySimilarCasesDescription: "Décrivez les faits, les personnes concernées et le résultat souhaité. La recherche utilise toute la description pour trouver des situations similaires.",
    incompleteSourcesTitle: "La vérification des sources est incomplète",
    incompleteSourcesDescription: "Certaines sources n’ont pas répondu. Nous ne pouvons pas encore confirmer la présence de résultats. Réessayez ou ouvrez une fonction ci-dessous.",
    globalSearchPlaceholder: "Question, terme juridique, personne, société ou numéro de dossier...",
    moreFactsTitle: "Précisez les faits",
    moreFactsDescription: "Vous avez saisi {count} caractères. La recherche de cas similaires en nécessite au moins {minimum}. Ajoutez les événements, les personnes impliquées et les conséquences.",
    closeNotice: "Fermer",
    lexicalCaseSearch: "Rechercher ces mots dans la jurisprudence",
    completeFacts: "Compléter la description",
    semanticTooLong: "Limitez la description à {count} caractères.",
    interpretationFailed: "L’interprétation de la recherche a échoué. Réessayez.",
    seoTitle: "Analyse Juridique IA - Recherche de Jurisprudence & Registre des Sociétés",
    seoDesc: "Plateforme professionnelle d'analyse juridique. Ce n'est pas un chatbot générique. Saisissez des faits réels pour identifier des dossiers similaires, des décisions de justice pertinentes et vérifier les finances des entreprises.",
    searchTypeLabel: "Type de recherche :",
    keywords: "Mots-clés",
    speta: "Exposé des Faits",
    spetaShort: "Description du Cas",
    perspective: "Perspectives",
    modulesSelected: "modules sélectionnés",
    moduleSelected: "module sélectionné",
    keywordsSearch: "Rechercher dans tous les modules",
    aiAnalysisLabel: "Analyse Sémantique IA",
    jurisAnalysisLabel: "Analyse de la Jurisprudence",
    viewPerspectiveBtn: "Voir les Perspectives",
    placeholderKeywords: "Mots-clés, questions, personnes, sociétés ou dossiers...",
    placeholderSpeta: "Décrivez la situation juridique en détail (minimum 200 caractères)...",
    examplesGroup: "Exemples de recherche",
    factualEx: "Scénario Factuel",
    caseSearchEx: "Recherche de Dossier",
    companyVerifEx: "Vérifier une Entreprise",
    usefulLinksGroup: "Liens utiles",
    docAnalysisLink: "Analyser un Document",
    newsLink: "Actualités Juridiques",
    videoLink: "Vidéo Juridique",
    eventsLink: "Événements",
    studentsLinksGroup: "Section Étudiants",
    calculatorsSectionHeader: "CALCULATEURS",
    audioQuizzesLink: "QCM Audio",
    audioLegislationLink: "Législation Audio",
    calculatorsLink: "Calculateurs",
    searchModulesHeader: "Rechercher dans les modules",
    directSearchHeader: "Recherche directe",
    legalDocumentsHeader: "Documents juridiques",
    optionalModules: "(optionnel — vide = tout rechercher)",
    resetModules: "Réinitialiser",
    infoBanner: "Saisissez une question ou des termes pour rechercher dans les bases de données.",
    bluetoothBannerBadge: "Unique en Roumanie ! ©",
    bluetoothBannerTitle: "QCM Audio avec Télécommande Bluetooth",
    bluetoothBannerDesc: "« Nous transformons la préparation aux examens du Barreau, de l'INM et des facultés de droit en une expérience plus libre et plus naturelle. Écoutez les dossiers dans votre casque, répondez via la télécommande Bluetooth et étudiez sans la contrainte d'un espace fermé. Moins de fatigue. Plus de concentration. »",
    bluetoothBannerAuthor: "Antoniu Olivian",
    bluetoothBannerRole: "Associé chez VerdictLine",
    bluetoothBannerCTA: "Démarrer la Session Audio →",
    placeholderKeywordsCount: "Mots-clés pour {count} modules sélectionnés...",
    mobileAttach: "Joindre",
    mobileDictate: "Dicter",
    mobileRemaining: "il vous reste {count} caractères",
    mobileOptimal: "Optimal",
    mobileOptionalLabel: "optionnel",
    resetSelection: "Réinitialiser la sélection",
    searchBtn: "Rechercher",
    analyzingCategories: "Nous analysons la base de données afin d'identifier les catégories pertinentes...",
    fasterSearchHint: "Pour obtenir une réponse plus rapidement, nous vous recommandons de sélectionner uniquement les modules utiles à votre recherche.",
    resultCount: "{count} résultat",
    resultsCount: "{count} résultats",
    benefitSmartTitle: "Recherche Intelligente",
    benefitSmartSub: "IA Avancée",
    benefitFastTitle: "Réponse Rapide",
    benefitFastSub: "Résultats pertinents",
    benefitSecureTitle: "Sécurité",
    benefitSecureSub: "Données protégées",
    mobileOptimalText: "Texte optimal pour l'analyse",
    mobileRemainingCharacters: "il vous reste {count} caractères",
    directSearchCategoryTitle: "Services et registres",
    selectSingleService: "Ouvrir un service individuel",
    desktopDirectNotice: "Les services et registres sont utilisés individuellement.",
    legalContentCategoryTitle: "Contenu juridique",
    selectMultipleSources: "Sélectionnez une ou plusieurs sources",
    desktopLegalNotice: "Vous pouvez sélectionner une ou plusieurs sources de Contenu juridique.",
    desktopPlaceholderKeywords: "Recherchez un problème juridique, un article de loi, une entreprise ou un dossier...",
    mainSearchPlaceholder: "Recherchez un problème juridique, un article de loi, une entreprise ou un dossier...",
    integratedSearchLine1: "Recherche intégrée dans la législation, la jurisprudence, la pratique judiciaire, le dictionnaire juridique, les modèles de documents et d'autres sources.",
    integratedSearchLine2: "Vous pouvez également rechercher par numéro de dossier, CUI, nom d'entreprise ou nom de personne.",
    bannerKeywordsInfo: "Moteur spécialisé de recherche et d'analyse juridique. Saisissez des mots-clés, un exposé des faits, un acte normatif ou un numéro de dossier.",
    bannerKeywordsInfoTitle: "Moteur spécialisé de recherche et d'analyse juridique",
    bannerKeywordsInfoSub: "Saisissez des mots-clés, un exposé des faits, un acte normatif ou un numéro de dossier.",
    bannerConflictTitle: "Vous pouvez sélectionner des modules exclusivement dans une seule catégorie. Choisissez soit un service dans \"Services et registres\", soit une ou plusieurs sources dans \"Contenu juridique\".",
    bannerConflictSubtitle: "Désélectionnez les sélections d'une des catégories pour continuer.",
    sourcesAll: "Toutes les {count} sources",
    sourcesConflict: "Sélection incompatible",
    sourcesSingle: "{name}",
    sourcesCount: "{count} sources sélectionnées",
    sourcesModalTitle: "Sources",
    sourcesModalSubtitle: "Personnalisez les modules interrogés",
    allModules: "Tous les modules",
    globalMode: "Mode global",
    popupConflictNote: "Vous avez sélectionné un service dans \"Services et registres\". Désélectionnez-le pour choisir des sources dans \"Contenu juridique\".",
    popupEmptyNote: "Sélectionnez au moins une source ou choisissez Tous les modules.",
    allModulesActive: "Tous les modules actifs",
    sourcesSelectedCount: "{count} sources sélectionnées",
    sourcesSingleCount: "{count} source sélectionnée",
    ecrisValidationTitle: "Entrez au moins 2 caractères pour rechercher des procès.",
    ecrisValidationExample: "Exemple: Adrian Nicolau ou Verdict Line SRL",
    questionNoticeTitle: "Vous pouvez rechercher en posant une question.",
    questionNoticeDesc: "Nous trouvons les informations pertinentes dans les sources disponibles.",
    sourcesVerificationWarning: "Certaines sources n'ont pas pu être vérifiées. Veuillez réessayer la vérification.",
    retryVerification: "Réessayer",
    companyIdentifiedBadge: "Société détectée",
    done: "Terminé",
    chooseSource: "Choisissez la source pour continuer",
    chooseSourceSubtitleConfirmed: "Nous avons identifié des informations dans les sources ci-dessous. Sélectionnez-en une pour consulter les résultats.",
    seeResults: "Voir les résultats",
    matterStageTitle: "Dans quel domaine du droit souhaitez-vous rechercher ?",
    matterStageSubtitle: "Nous avons trouvé des décisions de justice pertinentes dans les domaines ci-dessous. Choisissez-en un pour continuer.",
    seeCourtDecisions: "Voir les décisions de justice",
    seeAllIncludingUnclassified: "Voir toutes les décisions, y compris celles sans matière",
    matterDiscoveryFailed: "Impossible de charger les matières. Veuillez réessayer.",
    chooseAnotherMatter: "Choisir un autre domaine du droit",
    backToSources: "Retour aux sources",
    checkingAvailableMatters: "Vérification des domaines du droit disponibles…",
    matterGenericDesc: "Consultez les décisions de justice pertinentes dans ce domaine du droit.",
    listenLegislation: "Écouter la législation",
    audioPrepTitle: "Préparation audio aux concours",
    exploreOtherFeatures: "Explorer d'autres fonctions",
    audioBarouTitle: "Audio Admission Barreau",
    audioBarouDesc: "Écoutez la législation et les ressources audio pour le concours d'admission au Barreau.",
    audioInmTitle: "Audio Admission INM",
    audioInmDesc: "Étudiez en audio la législation pour le concours d'admission à la magistrature (INM).",
    audioSngTitle: "Audio Admission SNG",
    audioSngDesc: "Écoutez la législation et les ressources audio pour le concours des greffiers (SNG).",
    audioListenBadge: "Écouter la législation",
    sources: {
      dictionar: { desc: "Découvrez des définitions et explications claires pour les termes juridiques." },
      legislatie: { desc: "Consultez des articles de lois, codes et autres actes normatifs." },
      modele: { desc: "Trouvez des modèles de contrats, requêtes et formulaires juridiques prêts à l'emploi." },
      jurisprudenta: { desc: "Recherchez des décisions et jugements de la jurisprudence roumaine." },
      practica_neunitara: { desc: "Explorez les questions de droit analysées pour l'unification de la jurisprudence." },
      jurnal_practica_judiciara: { desc: "Consultez des analyses, recueils et décisions pertinentes de la pratique judiciaire." },
      firma: { desc: "Vérifiez les entreprises par identifiant fiscal ou raison sociale et consultez les informations disponibles." },
      agenda: { desc: "Trouvez les coordonnées des tribunaux et institutions judiciaires." },
      circumscriptii: { desc: "Identifiez les juridictions compétentes pour une commune, rue ou code postal." },
      persoane: { desc: "Identifiez les administrateurs et représentants légaux dans les registres d'entreprises." },
      litigii: { desc: "Consultez les dossiers judiciaires impliquant des personnes physiques ou morales." },
      dosar: { desc: "Recherchez un dossier par son numéro et consultez les informations disponibles." },
    },
    chooseSourceSubtitle: "Résultats trouvés dans {found} sur {total} sources sélectionnées.",
    chooseSourceSubtitleSingle: "Résultats trouvés dans 1 des {total} sources sélectionnées.",
    chooseSourceSubtitleGlobal: "Choisissez une catégorie pour explorer les {count} résultats trouvés pour « {query} ».",
    changeCategory: "Changer de catégorie",
    backToFoundSources: "Retour aux sources trouvées",
    viewingResultsFromSource: "Vous consultez les résultats de {source}",
    noResultsInSources: "Aucun résultat dans les sources sélectionnées",
    noResultsInSourcesDesc: "Aucun document trouvé pour « {query} » dans les sources sélectionnées.",
    searchAllSources: "Rechercher dans toutes les sources",
    modifySources: "Modifier les sources",
    overviewError: "Impossible de vérifier les sources sélectionnées pour le moment.",
    overviewErrorDesc: "Un problème de communication est survenu avec le serveur de recherche.",
    retry: "Réessayer",
    backToSearch: "Retour à la recherche",
    searchingInSources: "Recherche dans les sources sélectionnées...",
    pageHeading: "Recherche et analyse juridique",
    pageDescription: "Recherchez par mots-clés, décrivez un cas ou partez du texte d'un document joint.",
    similarCasesCta: "Pas familier avec les termes juridiques ? Trouvez des cas similaires en langage clair →",
    sourcesRecommended: "Sources de recherche ({count}) · Recommandé",
    sourcesModalHeading: "Sources de recherche ({count})",
    sourcesModalSub: "Services, registres et contenu juridique",
    sourcesModalChooseHint: "Choisissez où vous souhaitez rechercher. Vous hésitez ? Conservez le mode global recommandé et commencez votre recherche ; aucune personnalisation n'est nécessaire.",
    sourcesHowItWorks: "Comment ça marche ?",
    sourcesStep1: "Entrez les termes de recherche ou les données requises par le service choisi.",
    sourcesStep2: "Conservez le mode global ou choisissez un service individuel ou un ou plusieurs modules de contenu juridique.",
    sourcesStep3: "Cliquez sur Appliquer, puis recherchez. La sélection définit les pages ou modules de recherche ; les résultats dépendent de la requête et des données disponibles.",
    sourcesTip1: "Pour un article de loi, choisissez {leg}. Pour les décisions, choisissez {juris}. Si vous ne savez pas où se trouve la réponse, revenez au mode global. Il utilise le routage automatique et ne garantit pas la consultation des 12 options.",
    sourcesTip2: "Les services individuels ne se combinent pas entre eux ni avec les modules juridiques. Le sélecteur est disponible en mode Mots-clés ; Cas et Perspectives ont leurs propres parcours.",
    resetToRecommended: "Revenir à la sélection recommandée",
    recommendedGlobalMode: "Mode global recommandé",
    attachmentHelp: "PDF, DOCX, TXT ou images · max. 10 Mo · PDF : max. 3 pages",
    closeAttachmentMessage: "Fermer le message sur la pièce jointe",
    adequateLength: "Longueur adéquate",
    charactersNeeded: "{count} caractères requis",
    neededForLegalIssues: "requis pour les situations juridiques",
    tryExample: "Essayer un exemple",
    maxCharsDesc: "Conservez au maximum 8 000 caractères dans la description.",
    maxCharsField: "Conservez au maximum 8 000 caractères dans le champ pour la recherche de cas.",
    maxCharsKeywords: "Conservez au maximum 2 000 caractères dans le champ pour la recherche par mots-clés.",
    listening: "Écoute en cours...",
    backBtn: "Retour",
    keywordSearchBadge: "Recherche par mots-clés",
    caseNumberDetected: "Numéro de dossier détecté",
    ambiguousBadge: "Texte ambigu",
    tellWhatHappened: "Racontez ce qui s'est passé",
    caseSearch: "Recherche de dossier",
    companySearch: "Recherche d'entreprise",
    sessionExpiredNotice: "Votre session n'est plus active. Pour protéger votre compte et vos données, veuillez vous reconnecter pour continuer en toute sécurité.",
    legalSearchTitle: "Recherche juridique",
    directSearchLabel: "Saisissez directement votre recherche",
    directSearchHint: "Saisissez votre recherche dans le champ ou choisissez un exemple ci-dessous.",
    searchExamples: "Exemples de recherche",
    tryAnExample: "Essayer un exemple",
    previewExample: "Aperçu de l'exemple",
    cancelBtn: "Annuler",
    closeBtn: "Fermer",
    examplesPlatformFooter: "Exemples de fonctionnalités de la plateforme.",
    seeAllFeatures: "Voir toutes les fonctionnalités →",
    example_dosar_title: "Numéro de dossier",
    example_dosar_short: "N° dossier",
    example_dosar_desc: "Ceci est le format d'un numéro de dossier. Vous pouvez modifier le texte avant la recherche.",
    example_firma_title: "Code fiscal / Nom d'entreprise",
    example_firma_short: "Entreprise / Code fiscal",
    example_firma_desc: "Vous pouvez rechercher une société par sa raison sociale ou son code fiscal.",
    example_circumscriptii_title: "Ma juridiction compétente",
    example_circumscriptii_short: "Juridiction",
    example_circumscriptii_desc: "Entrez une localité pour identifier les tribunaux territorialement compétents.",
    example_persoane_title: "Recherche de personnes",
    example_persoane_short: "Personnes",
    example_persoane_desc: "Entrez le nom d'une personne pour identifier les informations disponibles sur la plateforme.",
    example_litigii_title: "Procédures judiciaires",
    example_litigii_desktop: "Procédures actives (ECRIS)",
    example_litigii_short: "Contentieux",
    example_litigii_desc: "Vous pouvez saisir le nom d'une personne ou d'une société pour vérifier les dossiers associés.",
    example_agenda_title: "Annuaire",
    example_agenda_short: "Annuaire",
    example_agenda_desc: "Recherchez des tribunaux ou institutions judiciaires pour obtenir leurs coordonnées.",
    example_dictionar_title: "Dictionnaire juridique",
    example_dictionar_short: "Dictionnaire",
    example_dictionar_desc: "Entrez le terme juridique dont vous cherchez la définition.",
    example_legislatie_title: "Législation",
    example_legislatie_short: "Législation",
    example_legislatie_desc: "Vous pouvez saisir un article de loi ou des termes issus d'un texte normatif.",
    example_modele_title: "Modèles d'actes et requêtes",
    example_modele_short: "Modèles",
    example_modele_desc: "Recherchez des modèles éditables de requêtes, contrats ou actes de procédure.",
    example_jurisprudenta_title: "Décisions de justice",
    example_jurisprudenta_short: "Jurisprudence",
    example_jurisprudenta_desc: "Recherchez des décisions de justice pertinentes et des jugements.",
    example_practica_neunitara_title: "Jurisprudence divergente",
    example_practica_neunitara_short: "Divergences",
    example_practica_neunitara_desc: "Identifiez les pourvois dans l'intérêt de la loi et les décisions préalables.",
    example_analiza_contract_title: "Analyse de contrat (IA)",
    example_analiza_contract_short: "Analyse de contrat",
    example_analiza_contract_desc: "Collez un contrat ou avenant pour la détection automatique des clauses et la corrélation législative.",
    example_jurnal_practica_judiciara_title: "Journal de pratique judiciaire",
    example_jurnal_practica_judiciara_short: "Journal pratique",
    example_jurnal_practica_judiciara_desc: "Découvrez des synthèses et commentaires récents de jurisprudence.",
    llmWelcomeTitle: "Un message de la part du LLM",
    llmWelcomeGreeting: "Bonjour !",
    llmWelcomeBody: "Par respect pour la justice et vos droits, je ne fournis ni **consultations** ni **conseils juridiques**. Je vous aide à découvrir et comparer des affaires similaires, afin de prendre des décisions éclairées aux côtés d'un avocat averti.",
    llmWelcomeInstruction: "Saisissez directement votre texte, sans introductions ni formules de politesse. Je vous guiderai si nécessaire.",
    llmWelcomeSignature: "Avec considération,\nLe LLM LegeaAplicată.",
    llmWelcomeConfirm: "Compris. Commençons ! →",
    aiNav: {
      title: "Navigation assistée par IA",
      manualSwitch: "Navigation manuelle",
      cancel: "Arrêter",
      selectPrompt: "Sélectionnez l'option appropriée pour continuer :",
      unsupportedConstraintsTitle: "Certaines conditions de votre demande ne sont pas disponibles comme filtres automatiques et ont été exclues :",
      stage: {
        interpreting_request: "Interprétation de la demande juridique…",
        searching_sources: "Vérification des sources et registres disponibles…",
        awaiting_court_selection: "Sélectionnez la juridiction souhaitée pour continuer",
        preparing_results: "Préparation des résultats pertinents…",
        completed: "Navigation terminée",
      },
    },
    llmWelcomeFootnote: "Affiché une seule fois et peut être rouvert depuis la page.",
    llmWelcomeReopen: "Un message de la part du LLM",
    rerankUpsellTitle: "{relevantCount} décisions pertinentes identifiées",
    rerankUpsellBasicDesc: "Affichage des {displayedCount} décisions les plus pertinentes selon votre abonnement Basic. L'abonnement Pro permet d'afficher jusqu'à 50 décisions pertinentes par recherche.",
    rerankUpsellGuestDesc: "Affichage des {displayedCount} décisions les plus pertinentes pour les visiteurs. Créez un compte gratuit Basic pour jusqu'à 20 décisions pertinentes ou choisissez Pro pour jusqu'à 50 décisions pertinentes.",
    rerankUpsellCtaPro: "Débloquer Pro",
    rerankUpsellCtaGuest: "Voir les abonnements",
    rerankProSummary: "{candidateCount} décisions candidates analysées. Affichage de {displayedCount} décisions pertinentes, classées par pertinence.",
    rerankAllRelevantShown: "Affichage des {displayedCount} décisions ayant franchi le seuil de pertinence."
  }
};

export default searchTranslations;
